<template>
  <!-- Account Wallet Page -->
  <PlatformRenderer>
    <template v-slot:onDesktop>
      <WalletDesktop />
    </template>
    <template v-slot:onMobile>
      <WalletMobile />
    </template>
  </PlatformRenderer>
</template>

<script>
import PlatformRenderer from '@/modules/platform/components/PlatformRenderer';
import WalletDesktop from './components/WalletDesktop.vue';
import WalletMobile from './components/WalletMobile.vue';

export default {
  name: 'Wallet',
  components: {
    PlatformRenderer,
    WalletDesktop,
    WalletMobile,
  },
};
</script>
